<template>
  <div class="refresh-all-bar">
    <div class="title">Refresh Content</div>
    <div class="buttons">
      <button
        type="button"
        class="btn btn-primary small"
        @click="$emit('refresh-all')"
      >
        Refresh All
      </button>
    </div>
  </div>
</template>
<script>
export default {
  emits: ["refresh-all"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.refresh-all-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  margin-top: 20px;
  margin-bottom: 10px;
  background-color: $gray-300;

  & > .title {
    font-size: 0.8rem;
    font-weight: bold;
  }

  & > .buttons {
    & > button {
      margin-left: 3px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
